import React, { useEffect, useState, useRef } from "react";
import Swal from "sweetalert2";
import api from "../../services/api";
import { PiEyeLight, PiEyeClosedLight } from "react-icons/pi";
import InputMask from "react-input-mask";
import "./minhaConta.scss";

export default function MinhaConta() {

    // =========================
    // ESTADOS
    // =========================

    const [loading, setLoading] = useState(false);
    const [mostrarSenha, setMostrarSenha] = useState(false);
    const [telefoneVerificado, setTelefoneVerificado] = useState(false);
    const [codigoSMS, setCodigoSMS] = useState("");
    const [mostrarCodigo, setMostrarCodigo] = useState(false);
    const [erroSenha, setErroSenha] = useState("");
    const [values, setValues] = useState({
        senhaAtual: "",
        novaSenha: "",
        confirmarSenha: ""
    });
    const [emailObrigatorio, setEmailObrigatorio] =
        useState(false);
    const [telefoneDisponivel, setTelefoneDisponivel] = useState(null);
    const [verificandoTelefone, setVerificandoTelefone] = useState(false);
    const telefoneTimeout = useRef(null);


    const handleAlterarEmail = async () => {

        // =====================================================
        // 1. INFORMAR NOVO E-MAIL
        // =====================================================

        const result = await Swal.fire({

            title: "Cadastrar e-mail",

            iconHtml: `
            <div class="email-alert-icon">
                <span>@</span>
            </div>
        `,

            html: `
            <div class="email-form-content">

                <div class="email-form-description">
                    Informe um e-mail válido para continuar
                    utilizando todos os recursos da plataforma.
                </div>

               <div class="email-input-wrapper">

    <label>
        Novo e-mail
    </label>

    <div class="email-input-container">

        <input
            id="novo-email"
            type="email"
            class="email-custom-input"
            placeholder="seuemail@exemplo.com"
            autocomplete="email"
        />

        <span
            id="email-status"
            class="email-status"
        ></span>

    </div>

    <div
        id="email-validation-message"
        class="email-validation-message"
    ></div>

</div>

                <div class="email-form-info">

                    <span class="email-info-dot"></span>

                    <span>
                        Após informar o e-mail, enviaremos um
                        código de confirmação para validar o endereço.
                    </span>

                </div>

            </div>
        `,

            background: "#0b1b28",

            color: "#ffffff",

            width: "520px",

            allowOutsideClick: false,

            allowEscapeKey: false,

            showCancelButton: true,

            confirmButtonText: "Continuar",

            cancelButtonText: "Cancelar",

            confirmButtonColor: "#1f6fa9",

            cancelButtonColor: "#162633",

            reverseButtons: true,

            customClass: {

                popup: "popup-email-obrigatorio",

                icon: "icone-email-obrigatorio",

                title: "titulo-email-obrigatorio",

                htmlContainer: "conteudo-email-obrigatorio",

                confirmButton: "botao-email-obrigatorio",

                cancelButton: "botao-cancelar-email"
            },

            didOpen: () => {

                const input =
                    document.getElementById("novo-email");

                const status =
                    document.getElementById("email-status");

                const message =
                    document.getElementById(
                        "email-validation-message"
                    );

                input?.focus();

                let timeout = null;

                input?.addEventListener("input", () => {

                    clearTimeout(timeout);

                    const email =
                        input.value.trim().toLowerCase();


                    // ==========================================
                    // RESET
                    // ==========================================

                    status.innerHTML = "";

                    message.innerHTML = "";

                    input.classList.remove(
                        "email-valid",
                        "email-invalid",
                        "email-checking"
                    );


                    // ==========================================
                    // VAZIO
                    // ==========================================

                    if (!email) {
                        return;
                    }


                    // ==========================================
                    // VALIDA FORMATO
                    // ==========================================

                    const emailValido =
                        /^[^\s@]+@[^\s@]+\.[^\s@]+$/;


                    if (!emailValido.test(email)) {

                        input.classList.add(
                            "email-invalid"
                        );

                        status.innerHTML = "✕";

                        message.innerHTML =
                            "Digite um endereço de e-mail válido.";

                        return;
                    }


                    // ==========================================
                    // AGUARDA USUÁRIO PARAR DE DIGITAR
                    // ==========================================

                    timeout = setTimeout(async () => {

                        input.classList.add(
                            "email-checking"
                        );

                        status.innerHTML =
                            `<span class="email-spinner"></span>`;

                        message.innerHTML =
                            "Verificando disponibilidade...";


                        try {

                            const idUsuario =
                                localStorage.getItem("id");


                            await api.post(
                                "/usuarios/verificar",
                                {
                                    email,
                                    id: idUsuario
                                },
                                {
                                    headers: {
                                        inova:
                                            `Bearer ${localStorage.getItem("inova")}`
                                    }
                                }
                            );


                            // ==================================
                            // DISPONÍVEL
                            // ==================================

                            input.classList.remove(
                                "email-checking"
                            );

                            input.classList.add(
                                "email-valid"
                            );

                            status.innerHTML = "✓";

                            message.innerHTML =
                                "E-mail disponível.";


                        } catch (error) {

                            input.classList.remove(
                                "email-checking"
                            );


                            // ==================================
                            // E-MAIL JÁ EXISTE
                            // ==================================

                            if (
                                error.response?.status === 400 &&
                                error.response?.data?.campo === "email"
                            ) {

                                input.classList.add(
                                    "email-invalid"
                                );

                                status.innerHTML = "✕";

                                message.innerHTML =
                                    error.response.data.mensagem ||
                                    "E-mail já está em uso.";

                                return;
                            }


                            // ==================================
                            // ERRO DESCONHECIDO
                            // ==================================

                            status.innerHTML = "⚠";

                            message.innerHTML =
                                "Não foi possível verificar o e-mail.";

                        }

                    }, 600);

                });

            },

            preConfirm: async () => {

                const input =
                    document.getElementById("novo-email");

                const novoEmail =
                    input?.value?.trim().toLowerCase();


                // ==========================================
                // OBRIGATÓRIO
                // ==========================================

                if (!novoEmail) {

                    Swal.showValidationMessage(
                        "Informe um e-mail para continuar."
                    );

                    return false;
                }


                // ==========================================
                // FORMATO
                // ==========================================

                const emailValido =
                    /^[^\s@]+@[^\s@]+\.[^\s@]+$/;


                if (!emailValido.test(novoEmail)) {

                    Swal.showValidationMessage(
                        "Informe um endereço de e-mail válido."
                    );

                    return false;
                }


                // ==========================================
                // VERIFICAR NOVAMENTE NO BACKEND
                // ==========================================

                try {

                    const idUsuario =
                        localStorage.getItem("id");


                    await api.post(
                        "/usuarios/verificar",
                        {
                            email: novoEmail,
                            id: idUsuario
                        },
                        {
                            headers: {
                                inova:
                                    `Bearer ${localStorage.getItem("inova")}`
                            }
                        }
                    );


                    // ======================================
                    // DISPONÍVEL
                    // ======================================

                    return {
                        novoEmail
                    };


                } catch (error) {

                    if (
                        error.response?.status === 400 &&
                        error.response?.data?.campo === "email"
                    ) {

                        Swal.showValidationMessage(
                            error.response.data.mensagem ||
                            "E-mail já está em uso."
                        );

                        return false;
                    }


                    Swal.showValidationMessage(
                        "Não foi possível verificar o e-mail."
                    );

                    return false;
                }
            }
        });


        // =====================================================
        // CANCELADO
        // =====================================================

        if (!result.isConfirmed) {
            return;
        }


        const { novoEmail } = result.value;


        // =====================================================
        // 2. CONFIRMAR E-MAIL
        // =====================================================

        const confirmarDados = await Swal.fire({

            title: "Confirme seu e-mail",

            iconHtml: `
            <div class="email-alert-icon email-alert-icon-small">
                <span>✓</span>
            </div>
        `,

            html: `
            <div class="email-confirm-content">

                <div class="email-confirm-description">
                    Confirme se o endereço abaixo está correto.
                </div>

                <div class="email-confirm-card">

                    <div class="email-confirm-label">
                        E-mail informado
                    </div>

                    <div
                        id="email-confirm-value"
                        class="email-confirm-value"
                    ></div>

                </div>

                <div class="email-confirm-info">

                    <span class="email-info-dot"></span>

                    <span>
                        Ao continuar, enviaremos um código de
                        confirmação para este endereço.
                    </span>

                </div>

            </div>
        `,

            background: "#0b1b28",

            color: "#ffffff",

            width: "520px",

            allowOutsideClick: false,

            allowEscapeKey: false,

            showCancelButton: true,

            confirmButtonText: "Enviar código",

            cancelButtonText: "Voltar",

            confirmButtonColor: "#1f6fa9",

            cancelButtonColor: "#162633",

            reverseButtons: true,

            customClass: {

                popup: "popup-email-obrigatorio",

                icon: "icone-email-obrigatorio",

                title: "titulo-email-obrigatorio",

                htmlContainer: "conteudo-email-obrigatorio",

                confirmButton: "botao-email-obrigatorio",

                cancelButton: "botao-cancelar-email"
            },

            didOpen: () => {

                /*
                 * Usamos textContent para evitar
                 * inserir o e-mail diretamente
                 * como HTML.
                 */

                const emailElement =
                    document.getElementById(
                        "email-confirm-value"
                    );

                if (emailElement) {

                    emailElement.textContent =
                        novoEmail;

                }
            }
        });


        // =====================================================
        // VOLTOU
        // =====================================================

        if (!confirmarDados.isConfirmed) {

            return handleAlterarEmail();

        }


        // =====================================================
        // 3. ENVIANDO CÓDIGO
        // =====================================================

        Swal.fire({

            title: "Enviando código",

            background: "#0b1b28",

            color: "#ffffff",

            width: "420px",

            allowOutsideClick: false,

            allowEscapeKey: false,

            showConfirmButton: false,

            customClass: {

                popup: "popup-email-loading",

                title: "titulo-email-loading"
            },

            html: `

            <div class="email-loading-content">

                <div class="email-loading-spinner"></div>

                <div class="email-loading-text">
                    Estamos enviando um código de
                    confirmação para seu e-mail.
                </div>

                <div class="email-loading-email">
                    ${novoEmail.replace(/</g, "&lt;").replace(/>/g, "&gt;")}
                </div>

            </div>

        `
        });


        try {

            // =================================================
            // ENVIA CÓDIGO
            // =================================================

            await api.put(

                "/usuario/alterar-email",

                {
                    novoEmail
                },

                {
                    headers: {

                        inova:
                            `Bearer ${localStorage.getItem("inova")}`
                    }
                }
            );


            // =================================================
            // 4. CÓDIGO
            // =================================================

            // =================================================
            // 4. CÓDIGO DO E-MAIL
            // =================================================

            const codigoModal = await Swal.fire({

                title: "Confirme seu e-mail",

                iconHtml: `
        <div class="email-alert-icon email-alert-icon-code">
            <span>✉</span>
        </div>
    `,

                html: `
        <div class="codigo-email-content">

            <div class="codigo-email-description">

                Enviamos um código de 6 dígitos para:

                <div
                    id="codigo-email-destino"
                    class="codigo-email-destino"
                ></div>

            </div>


            <div class="codigo-input-wrapper">

                <input
                    id="codigo-email"
                    type="text"
                    inputmode="numeric"
                    maxlength="6"
                    autocomplete="one-time-code"
                    placeholder="000000"
                    class="codigo-email-input"
                />

            </div>


            <div class="codigo-email-help">

                Digite o código recebido por e-mail
                para confirmar seu novo endereço.

            </div>

        </div>
    `,

                background: "#0b1b28",

                color: "#ffffff",

                width: "500px",

                allowOutsideClick: false,

                allowEscapeKey: false,

                showCancelButton: true,

                confirmButtonText: "Confirmar código",

                cancelButtonText: "Cancelar",

                confirmButtonColor: "#1f6fa9",

                cancelButtonColor: "#162633",

                reverseButtons: true,

                customClass: {

                    popup: "popup-email-obrigatorio",

                    icon: "icone-email-obrigatorio",

                    title: "titulo-email-obrigatorio",

                    htmlContainer: "conteudo-email-obrigatorio",

                    confirmButton: "botao-email-obrigatorio",

                    cancelButton: "botao-cancelar-email"

                },

                didOpen: () => {

                    // ==========================================
                    // MOSTRA O NOVO E-MAIL
                    // ==========================================

                    const destino =
                        document.getElementById(
                            "codigo-email-destino"
                        );

                    if (destino) {

                        destino.textContent =
                            novoEmail;

                    }


                    // ==========================================
                    // INPUT
                    // ==========================================

                    const input =
                        document.getElementById(
                            "codigo-email"
                        );

                    input?.focus();


                    // ==========================================
                    // SOMENTE NÚMEROS
                    // ==========================================

                    input?.addEventListener(
                        "input",
                        (event) => {

                            event.target.value =
                                event.target.value
                                    .replace(/\D/g, "")
                                    .slice(0, 6);

                        }
                    );

                },


                preConfirm: async () => {

                    const input =
                        document.getElementById(
                            "codigo-email"
                        );

                    const codigo =
                        input?.value?.trim();


                    // ==========================================
                    // VALIDAÇÃO
                    // ==========================================

                    if (!codigo) {

                        Swal.showValidationMessage(
                            "Digite o código enviado para seu e-mail."
                        );

                        return false;
                    }


                    if (codigo.length !== 6) {

                        Swal.showValidationMessage(
                            "O código deve possuir 6 dígitos."
                        );

                        return false;
                    }


                    // ==========================================
                    // CONFIRMA CÓDIGO DO E-MAIL
                    // ==========================================

                    try {

                        await api.put(

                            "/usuario/confirmar-alteracao-email",

                            {
                                codigo
                            },

                            {
                                headers: {

                                    inova:
                                        `Bearer ${localStorage.getItem("inova")}`

                                }
                            }

                        );

                        return true;


                    } catch (error) {

                        console.log(
                            "ERRO CÓDIGO E-MAIL:",
                            error.response?.data || error
                        );

                        Swal.showValidationMessage(

                            error.response?.data?.mensagem ||

                            "O código informado é inválido ou expirou."

                        );

                        return false;
                    }

                }

            });


            // =================================================
            // CANCELADO
            // =================================================

            if (!codigoModal.isConfirmed) {

                return;

            }


            // =================================================
            // 5. SUCESSO
            // =================================================

            await Swal.fire({

                icon: "success",

                title: "E-mail confirmado",

                text:
                    "Seu novo e-mail foi cadastrado e validado com sucesso.",

                background: "#0b1b28",

                color: "#ffffff",

                confirmButtonColor: "#1f6fa9",

                confirmButtonText: "Continuar",

                customClass: {

                    popup: "popup-email-obrigatorio",

                    title: "titulo-email-obrigatorio",

                    confirmButton: "botao-email-obrigatorio"
                }
            });


            // =================================================
            // LIBERA SISTEMA
            // =================================================

            setEmailObrigatorio(false);

            await carregarUsuario();


        } catch (error) {

            // =================================================
            // ERRO
            // =================================================

            Swal.fire({

                icon: "error",

                title: "Não foi possível concluir",

                text:
                    error.response?.data?.mensagem ||

                    "Ocorreu um erro ao alterar seu e-mail.",

                background: "#0b1b28",

                color: "#ffffff",

                confirmButtonColor: "#1f6fa9",

                confirmButtonText: "Entendi",

                customClass: {

                    popup: "popup-email-obrigatorio",

                    title: "titulo-email-obrigatorio",

                    confirmButton: "botao-email-obrigatorio"
                }

            });

        }
    };



    // =========================
    // CARREGAR DADOS USUÁRIO
    // =========================

    useEffect(() => {
        carregarUsuario();
    }, []);

    // =========================
    // BUSCAR DADOS
    // =========================
    const carregarUsuario = async () => {

        try {

            const response = await api.get(

                "/dadosConta",

                {
                    headers: {

                        inova:
                            `Bearer ${localStorage
                                .getItem("inova")}`,
                    },
                }
            );

            console.log(
                `RESPOSTA ${localStorage}`
            );

            // =========================
            // VALIDAR EMAIL
            // =========================

            const emailValido =
                /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

            const emailUsuario =
                response.data.email || "";

            const emailVerificado =
                emailValido.test(emailUsuario);

            // =========================
            // SET VALUES
            // =========================

            setValues({

                nome:
                    response.data.nome || "",

                email:
                    response.data.email || "",

                telefone:
                    response.data.telefone || "",

                email_verificado:
                    emailVerificado,

                novaSenha: "",

                confirmarSenha: "",
            });

            // =========================
            // EMAIL INVALIDO
            // =========================

            if (!emailVerificado) {

                // BLOQUEIA SISTEMA
                setEmailObrigatorio(true);

                Swal.fire({
                    title: "E-mail obrigatório",

                    iconHtml: `
        <div class="email-alert-icon">
            <span>!</span>
        </div>
    `,

                    html: `
        <div class="email-modal-content">

            <div class="email-modal-description">
                Seu cadastro ainda não possui um
                e-mail válido.
            </div>

            <div class="email-modal-info">

                <span class="email-modal-dot"></span>

                <span>
                    Para continuar utilizando todos os recursos
                    da plataforma, cadastre e valide um
                    e-mail válido.
                </span>

            </div>

        </div>
    `,

                    background: "#0b1b28",

                    color: "#ffffff",

                    confirmButtonColor: "#1f6fa9",

                    confirmButtonText: "Cadastrar E-mail",

                    allowOutsideClick: false,

                    allowEscapeKey: false,

                    backdrop: "rgba(3, 10, 15, 0.82)",

                    customClass: {
                        popup: "popup-email-obrigatorio",
                        icon: "icone-email-obrigatorio",
                        title: "titulo-email-obrigatorio",
                        htmlContainer: "conteudo-email-obrigatorio",
                        confirmButton: "botao-email-obrigatorio"
                    }

                }).then(() => {

                    handleAlterarEmail();

                });

            } else {

                // LIBERA SISTEMA
                setEmailObrigatorio(false);
            }

        } catch (error) {

            console.log(
                error.response?.data
            );

            Swal.fire({

                background: "#111827",

                color: "#f9fafb",

                title: "Erro",

                text:
                    "Não foi possível carregar seus dados.",

                confirmButtonColor: "#ef4444",
            });
        }
    };

    // =========================
    // ALTERAR INPUTS
    // =========================

    const handleChange = (e) => {

        const { name, value } = e.target;


        setValues((prev) => {

            const novosValores = {
                ...prev,
                [name]: value,
            };


            // =========================
            // VALIDAR SENHAS
            // =========================

            if (
                novosValores.senhaAtual &&
                novosValores.novaSenha &&
                novosValores.senhaAtual !== novosValores.novaSenha
            ) {

                setErroSenha(
                    "As senhas não coincidem."
                );

            } else {

                setErroSenha("");

            }


            return novosValores;

        });


        // =====================================================
        // VERIFICAR TELEFONE
        // =====================================================

        if (name === "telefone") {
            clearTimeout(telefoneTimeout.current);

            setTelefoneDisponivel(null);

            const telefoneLimpo = value.replace(/\D/g, "");

            if (telefoneLimpo.length !== 11) {
                setVerificandoTelefone(false);
                return;
            }

            setVerificandoTelefone(true);

            telefoneTimeout.current = setTimeout(() => {
                verificarDisponibilidadeTelefone(telefoneLimpo);
            }, 600);
        }

    };

    // =========================
    // SALVAR ALTERAÇÕES
    // =========================

    const handleSalvar = async () => {

        // =========================
        // VALIDACOES CADASTRO
        // =========================

        const problemas = [];

        // EMAIL
        if (emailObrigatorio) {

            problemas.push(
                "E-mail válido e verificado"
            );
        }

        // SENHA
        if (
            !values.senhaAtual ||
            !values.novaSenha
        ) {

            problemas.push(
                "Atualização de senha"
            );
        }

        // =========================
        // POSSUI PROBLEMAS
        // =========================

        if (problemas.length > 0) {

            Swal.fire({

                icon: "warning",

                title: "Atualização obrigatória",

                background: "#111827",

                color: "#f9fafb",

                confirmButtonColor: "#2563eb",

                html: `

            <div style="
                text-align:left;

                line-height:1.7;

                color:#cbd5e1;

                margin-top:10px;
            ">

                Detectamos que algumas
                informações precisam ser
                atualizadas antes de continuar.

                <br/><br/>

                <div style="
                    padding:14px;

                    border-radius:12px;

                    background:#0f172a;

                    border:
                        1px solid rgba(255,255,255,0.06);
                ">

                    ${problemas.map(item => `

                        <div style="
                            display:flex;
                            align-items:center;

                            gap:10px;

                            margin-bottom:10px;

                            color:#f8fafc;
                        ">

                            <span style="
                                color:#f59e0b;

                                font-size:16px;
                            ">
                                •
                            </span>

                            ${item}

                        </div>

                    `).join("")}

                </div>

            </div>
            `
            });

            return;
        }

        // =========================
        // SENHAS DIFERENTES
        // =========================

        if (
            values.senhaAtual !== values.novaSenha
        ) {

            Swal.fire({

                icon: "warning",

                title: "Senhas diferentes",

                text:
                    "As senhas precisam ser iguais.",

                background: "#111827",

                color: "#f9fafb",

                confirmButtonColor: "#2563eb",
            });

            return;
        }

        // =========================
        // SENHA MINIMA
        // =========================

        if (
            values.senhaAtual.length < 8
        ) {

            Swal.fire({

                icon: "warning",

                title: "Senha muito curta",

                text:
                    "A senha precisa ter pelo menos 8 caracteres.",

                background: "#111827",

                color: "#f9fafb",

                confirmButtonColor: "#2563eb",
            });

            return;
        }

        // =========================
        // CONFIRMAÇÃO
        // =========================

        const result = await Swal.fire({
            background: "#0b1623",
            color: "#f8fafc",

            width: "470px",

            html: `
        <div class="salvar-alteracoes-modal">

            <!-- HEADER -->

            <div class="salvar-alteracoes-header">

                <div class="salvar-alteracoes-icon">
                    <svg
                        width="21"
                        height="21"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M12 3L20 7V12C20 16.5 16.8 20.4 12 21C7.2 20.4 4 16.5 4 12V7L12 3Z"
                            stroke="currentColor"
                            stroke-width="1.7"
                            stroke-linejoin="round"
                        />

                        <path
                            d="M8.5 12L11 14.5L15.5 10"
                            stroke="currentColor"
                            stroke-width="1.8"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                    </svg>
                </div>

                <div class="salvar-alteracoes-title">
                    Confirmar alterações
                </div>

                <div class="salvar-alteracoes-description">
                    Confira os dados abaixo antes de salvar.
                </div>

            </div>


            <!-- RESUMO -->

            <div class="salvar-alteracoes-resumo">

                <!-- EMAIL -->

                <div class="salvar-item">

                    <div class="salvar-item-label">
                        E-mail
                    </div>

                    <div class="salvar-item-value">
                        ${values.email || "Não informado"}
                    </div>

                </div>


                <!-- TELEFONE -->

                <div class="salvar-item">

                    <div class="salvar-item-label">
                        Telefone
                    </div>

                    <div class="salvar-item-value">
                        ${formatarTelefone(values.telefone || "") || "Não informado"}
                    </div>

                </div>


                <!-- SENHA -->

                <div class="salvar-item">

                    <div class="salvar-item-label">
                        Nova senha
                    </div>

                    <div class="salvar-item-password">

                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>
                        <span></span>

                    </div>

                </div>

            </div>


            <!-- AVISO -->

            <div class="salvar-alteracoes-aviso">

                <div class="salvar-aviso-icon">
                    !
                </div>

                <div>
                    Após salvar, sua senha será atualizada
                    e será necessário entrar novamente.
                </div>

            </div>

        </div>
    `,

            showCancelButton: true,

            confirmButtonText: "Salvar alterações",

            cancelButtonText: "Cancelar",

            confirmButtonColor: "#2563eb",

            cancelButtonColor: "#172235",

            reverseButtons: true,

            allowOutsideClick: false,

            customClass: {
                popup: "salvar-alteracoes-popup",
                actions: "salvar-alteracoes-actions",
                confirmButton: "salvar-alteracoes-confirmar",
                cancelButton: "salvar-alteracoes-cancelar"
            }
        });

        if (!result.isConfirmed) return;

        try {

            setLoading(true);

            // =========================
            // LOADING
            // =========================

            Swal.fire({

                title: "Atualizando senha",

                background: "#111827",

                color: "#f9fafb",

                width: 420,

                html: `

            <div style="
                display:flex;
                flex-direction:column;
                align-items:center;

                margin-top:18px;
            ">

                <div style="
                    width:42px;
                    height:42px;

                    border-radius:50%;

                    border:3px solid rgba(255,255,255,0.08);

                    border-top:3px solid #2563eb;

                    animation: spinSwal 0.8s linear infinite;
                "></div>

                <div style="
                    margin-top:18px;

                    color:#cbd5e1;

                    font-size:14px;
                ">
                    Salvando alterações...
                </div>

            </div>

            <style>

                @keyframes spinSwal {

                    0% {
                        transform: rotate(0deg);
                    }

                    100% {
                        transform: rotate(360deg);
                    }
                }

            </style>
            `,

                showConfirmButton: false,

                allowOutsideClick: false,

                allowEscapeKey: false,
            });

            // =========================
            // REQUEST
            // =========================

            await api.put(

                "/usuario/atualizar-senha-logado",

                {
                    novaSenha: values.novaSenha
                },

                {
                    headers: {

                        inova:
                            `Bearer ${localStorage
                                .getItem("inova")
                            }`,
                    },
                }
            );

            // =========================
            // SUCESSO
            // =========================

            Swal.fire({

                background: "#111827",

                color: "#f9fafb",

                width: 430,

                html: `

            <div style="
                display:flex;
                flex-direction:column;
                align-items:center;

                padding:12px 6px;
            ">

                <div style="
                    width:72px;
                    height:72px;

                    border-radius:50%;

                    background:
                        rgba(34,197,94,0.12);

                    display:flex;
                    align-items:center;
                    justify-content:center;

                    margin-bottom:18px;
                ">

                    <div style="
                        font-size:38px;

                        color:#22c55e;
                    ">
                        ✓
                    </div>

                </div>

                <div style="
                    font-size:22px;

                    font-weight:700;

                    margin-bottom:8px;

                    color:#ffffff;
                ">
                    Senha atualizada
                </div>

                <div style="
                    color:#cbd5e1;

                    font-size:14px;

                    line-height:1.6;

                    text-align:center;

                    max-width:300px;
                ">
                    Sua senha foi alterada com sucesso.
                    Você será redirecionado para o login.
                </div>

            </div>
            `,

                timer: 2200,

                showConfirmButton: false,
            });

            // =========================
            // REDIRECIONA LOGIN
            // =========================

            setTimeout(() => {

                localStorage.removeItem("inova");

                window.location.href = "/";

            }, 2200);

        } catch (error) {

            console.log(

                error.response?.data ||

                error.message ||

                error
            );

            Swal.fire({

                background: "#111827",

                color: "#f9fafb",

                title: "Erro",

                text:
                    error.response?.data?.mensagem ||

                    "Não foi possível atualizar sua conta.",

                confirmButtonColor: "#ef4444",
            });

        } finally {

            setLoading(false);
        }
    };
    //=======================================================
    //VALIDAÇÃO DE SENHA , VERIFICAR SE AS SENHAS SÃO IGUAIS
    //=======================================================
    const validarSenhas = () => {

        if (
            values.senhaAtual &&
            values.novaSenha &&
            values.senhaAtual !== values.novaSenha
        ) {

            setErroSenha(
                "As senhas não coincidem."
            );

            return;
        }

        setErroSenha("");
    };
    //======================
    //ENVIAR CODIGO VIA SMS
    //======================
    const handleEnviarCodigo = async () => {
        try {
            // ==========================================
            // ENVIA CÓDIGO SMS
            // ==========================================

            await api.post(
                "/enviarCodigoTelefone",
                {
                    telefone: values.telefone
                },
                {
                    headers: {
                        inova: `Bearer ${localStorage.getItem("inova")}`
                    }
                }
            );

            // ==========================================
            // MODAL DO CÓDIGO
            // ==========================================

            const codigoModal = await Swal.fire({
                html: `
        <div class="telefone-verificacao-modal">

            <!-- ÍCONE -->
            <div class="telefone-verificacao-icon">
                <svg
                    width="22"
                    height="22"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M7 3H17C18.1 3 19 3.9 19 5V19C19 20.1 18.1 21 17 21H7C5.9 21 5 20.1 5 19V5C5 3.9 5.9 3 7 3Z"
                        stroke="currentColor"
                        stroke-width="1.8"
                    />

                    <path
                        d="M9 18H15"
                        stroke="currentColor"
                        stroke-width="1.8"
                        stroke-linecap="round"
                    />
                </svg>
            </div>

            <!-- TÍTULO -->
            <h2 class="telefone-verificacao-title">
                Verificar telefone
            </h2>

            <!-- DESCRIÇÃO -->
            <p class="telefone-verificacao-description">
                Enviamos um código de segurança para o número:
            </p>

            <!-- TELEFONE -->
            <div class="telefone-verificacao-number">
                ${formatarTelefone(values.telefone)}
            </div>

            <!-- LABEL -->
            <div class="telefone-codigo-label">
                Código de verificação
            </div>

            <!-- CÓDIGO -->
            <div class="telefone-codigo-inputs">

                <input
                    id="codigo-telefone-1"
                    maxlength="1"
                    inputmode="numeric"
                    autocomplete="one-time-code"
                />

                <input
                    id="codigo-telefone-2"
                    maxlength="1"
                    inputmode="numeric"
                />

                <input
                    id="codigo-telefone-3"
                    maxlength="1"
                    inputmode="numeric"
                />

                <span class="telefone-codigo-separador"></span>

                <input
                    id="codigo-telefone-4"
                    maxlength="1"
                    inputmode="numeric"
                />

                <input
                    id="codigo-telefone-5"
                    maxlength="1"
                    inputmode="numeric"
                />

                <input
                    id="codigo-telefone-6"
                    maxlength="1"
                    inputmode="numeric"
                />

            </div>

            <!-- AJUDA -->
            <div class="telefone-verificacao-help">
                Digite o código de 6 dígitos recebido por SMS.
            </div>

        </div>
    `,

                background: "#0b1623",

                color: "#ffffff",

                width: "420px",

                padding: "28px",

                showCancelButton: true,

                confirmButtonText: "Confirmar telefone",

                cancelButtonText: "Cancelar",

                confirmButtonColor: "#2563eb",

                cancelButtonColor: "transparent",

                allowOutsideClick: false,

                allowEscapeKey: false,

                focusConfirm: false,

                customClass: {
                    popup: "telefone-verificacao-popup",
                    actions: "telefone-verificacao-actions",
                    confirmButton: "telefone-verificacao-confirmar",
                    cancelButton: "telefone-verificacao-cancelar"
                },

                didOpen: () => {

                    const inputs = [
                        document.getElementById("codigo-telefone-1"),
                        document.getElementById("codigo-telefone-2"),
                        document.getElementById("codigo-telefone-3"),
                        document.getElementById("codigo-telefone-4"),
                        document.getElementById("codigo-telefone-5"),
                        document.getElementById("codigo-telefone-6")
                    ];

                    inputs[0]?.focus();

                    inputs.forEach((input, index) => {

                        input.addEventListener("input", (event) => {

                            event.target.value =
                                event.target.value
                                    .replace(/\D/g, "")
                                    .slice(0, 1);

                            if (
                                event.target.value &&
                                index < inputs.length - 1
                            ) {
                                inputs[index + 1].focus();
                            }
                        });

                        input.addEventListener("keydown", (event) => {

                            if (
                                event.key === "Backspace" &&
                                !input.value &&
                                index > 0
                            ) {
                                inputs[index - 1].focus();
                            }
                        });

                        input.addEventListener("paste", (event) => {

                            event.preventDefault();

                            const codigo =
                                event.clipboardData
                                    .getData("text")
                                    .replace(/\D/g, "")
                                    .slice(0, 6);

                            codigo.split("").forEach((numero, i) => {
                                if (inputs[i]) {
                                    inputs[i].value = numero;
                                }
                            });

                            if (codigo.length === 6) {
                                inputs[5]?.focus();
                            }
                        });

                    });
                },

                preConfirm: async () => {

                    const codigo = [
                        document.getElementById("codigo-telefone-1")?.value,
                        document.getElementById("codigo-telefone-2")?.value,
                        document.getElementById("codigo-telefone-3")?.value,
                        document.getElementById("codigo-telefone-4")?.value,
                        document.getElementById("codigo-telefone-5")?.value,
                        document.getElementById("codigo-telefone-6")?.value
                    ].join("");

                    if (codigo.length !== 6) {

                        Swal.showValidationMessage(
                            "Digite os 6 dígitos do código."
                        );

                        return false;
                    }

                    try {

                        await api.post(
                            "/validarCodigoTelefone",
                            {
                                telefone: values.telefone,
                                codigo: codigo
                            },
                            {
                                headers: {
                                    inova:
                                        `Bearer ${localStorage.getItem("inova")}`
                                }
                            }
                        );

                        return true;

                    } catch (error) {

                        console.log(
                            "ERRO CÓDIGO SMS:",
                            error.response?.data || error
                        );

                        Swal.showValidationMessage(
                            error.response?.data?.mensagem ||
                            "Código inválido ou expirado."
                        );

                        return false;
                    }
                }
            });

            // ==========================================
            // CANCELADO
            // ==========================================

            if (!codigoModal.isConfirmed) {
                return;
            }

            // ==========================================
            // TELEFONE CONFIRMADO
            // ==========================================

            setValues((prev) => ({
                ...prev,
                telefone_verificado: true
            }));

            setTelefoneDisponivel(true);

            await Swal.fire({
                icon: "success",

                title: "Telefone confirmado",

                text: "Seu telefone foi verificado com sucesso.",

                background: "#0b1b28",
                color: "#ffffff",

                confirmButtonColor: "#22c55e",

                confirmButtonText: "Continuar"
            });

        } catch (error) {

            console.log(
                "ERRO AO ENVIAR SMS:",
                error.response?.data || error
            );

            Swal.fire({
                icon: "error",

                title: "Erro",

                text:
                    error.response?.data?.mensagem ||
                    "Não foi possível enviar o código.",

                background: "#0b1b28",
                color: "#ffffff",

                confirmButtonColor: "#ef4444"
            });
        }
    };
    //VALIDAÇÃO CODIGO SMS
    const handleValidarCodigo = async () => {

        try {

            await api.post(

                "/validarCodigoTelefone",

                {

                    telefone: values.telefone,

                    codigo: codigoSMS
                },

                {

                    headers: {

                        inova:
                            `Bearer ${localStorage
                                .getItem("inova")
                            }`,
                    },
                }
            );

            setValues(prev => ({
                ...prev,
                telefone_verificado: true
            }));

            setMostrarCodigo(false);

            Swal.fire({

                icon: "success",

                title: "Telefone confirmado",

                background: "#111827",

                color: "#fff",

                confirmButtonColor: "#22c55e",
            });

        } catch (error) {

            console.log(
                error.response?.data ||
                error
            );

            Swal.fire({

                icon: "error",

                title: "Código inválido",

                background: "#111827",

                color: "#fff",

                confirmButtonColor: "#ef4444",
            });
        }
    };
    // =========================
    // JSX
    // =========================

    //FORMATAÇÃO DE NUMERO DE TELEFONE 
    const formatarTelefone = (telefone) => {

        // remove tudo que não for número
        const numeros = telefone.replace(/\D/g, "");

        // pega apenas os 11 primeiros números
        const limpo = numeros.slice(0, 11);

        // formata
        return limpo.replace(
            /(\d{2})(\d{5})(\d{4})/,
            "($1) $2-$3"
        );
    };

    const verificarDisponibilidadeTelefone = async (telefone) => {
        setTelefoneDisponivel(null);

        if (telefone.length !== 11) {
            return;
        }

        setVerificandoTelefone(true);

        try {
            const idUsuario = localStorage.getItem("id");

            console.log("📱 TELEFONE ENVIADO:", telefone);

            await api.post(
                "/usuario/verificar-telefone",
                {
                    telefone: telefone,
                    id: idUsuario
                },
                {
                    headers: {
                        inova: `Bearer ${localStorage.getItem("inova")}`
                    }
                }
            );

            setTelefoneDisponivel(true);

        } catch (error) {
            console.log(
                "VERIFICAR TELEFONE:",
                error.response?.data
            );

            if (
                error.response?.status === 400 ||
                error.response?.status === 409
            ) {
                setTelefoneDisponivel(false);
            } else {
                setTelefoneDisponivel(null);
            }

        } finally {
            setVerificandoTelefone(false);
        }
    };





    return (
        <div className="conta-container">

            <div className="conta-card">

                {/* HEADER */}

                <div className="conta-header">

                    <div>
                        <h2>Minha conta</h2>

                        <p>
                            Gerencie seus dados e mantenha sua conta segura.
                        </p>
                    </div>

                </div>


                <div className="conta-body">


                    {/* =====================================
                INFORMAÇÕES PESSOAIS
            ===================================== */}

                    <div className="conta-section">

                        <div className="conta-section-header">

                            <span className="section-line"></span>

                            <div>
                                <h3>Informações pessoais</h3>

                                <p>
                                    Dados utilizados para identificar sua conta.
                                </p>
                            </div>

                        </div>


                        {/* NOME */}

                        <div className="conta-field">

                            <label>Nome</label>

                            <input
                                type="text"
                                name="nome"
                                className="conta-input"
                                value={values.nome}
                                onChange={handleChange}
                            />

                        </div>


                        {/* EMAIL */}

                        <div className="conta-field">

                            <label>E-mail</label>

                            <div className="conta-input-row">

                                <input
                                    type="email"
                                    name="email"
                                    className="conta-input"
                                    value={values.email}
                                    onChange={handleChange}
                                    readOnly
                                />

                                <div
                                    className={
                                        values?.email_verificado
                                            ? "campo-status status-ok"
                                            : "campo-status status-error"
                                    }
                                >

                                    {values?.email_verificado
                                        ? "✓ Verificado"
                                        : "✕ Não verificado"
                                    }

                                </div>

                            </div>


                            <button
                                type="button"
                                className="alterar-email-text"
                                onClick={handleAlterarEmail}
                            >
                                Alterar e-mail

                            </button>

                        </div>


                        {/* TELEFONE */}

                        <div className="conta-field">

                            <label>Telefone</label>

                            <div className="conta-input-row">

                                <div className="telefone-wrapper">

                                    <InputMask
                                        mask="(99) 99999-9999"

                                        value={
                                            values?.telefone
                                                ? values.telefone
                                                    .replace(/\D/g, "")
                                                    .replace(/^55/, "")
                                                : ""
                                        }

                                        onChange={handleChange}

                                        autoComplete="off"
                                    >

                                        {(inputProps) => (

                                            <input
                                                {...inputProps}

                                                type="text"

                                                name="telefone"

                                                className={`
                            conta-input
                            ${telefoneDisponivel === true
                                                        ? "telefone-input-ok"
                                                        : telefoneDisponivel === false
                                                            ? "telefone-input-erro"
                                                            : ""
                                                    }
                        `}

                                                placeholder="(11) 99999-9999"
                                            />

                                        )}

                                    </InputMask>

                                    {/* STATUS */}

                                    <div className="telefone-status">

                                        {verificandoTelefone ? (

                                            <div className="telefone-checking">
                                                <span className="telefone-spinner"></span>
                                                Verificando...
                                            </div>

                                        ) : telefoneDisponivel === false ? (

                                            <div className="telefone-error">
                                                ✕ Já cadastrado
                                            </div>

                                        ) : telefoneDisponivel === true ? (

                                            <div className="telefone-disponivel-container">

                                                <div className="telefone-ok">
                                                    ✓ Disponível
                                                </div>

                                                <button
                                                    type="button"
                                                    className="btn-verificar-telefone"
                                                    onClick={handleEnviarCodigo}
                                                >
                                                    Verificar
                                                </button>

                                            </div>

                                        ) : values?.telefone_verificado ? (

                                            <div className="telefone-ok">
                                                ✓ Verificado
                                            </div>

                                        ) : (

                                            <button
                                                type="button"
                                                className="btn-verificar-telefone"
                                                onClick={handleEnviarCodigo}
                                            >
                                                Verificar
                                            </button>

                                        )}

                                    </div>

                                </div>

                            </div>


                            {/* MENSAGEM */}

                            {telefoneDisponivel === false && (

                                <div className="telefone-validation-message">

                                    Este número já está vinculado a outra conta.

                                </div>

                            )}

                            {telefoneDisponivel === true && (

                                <div className="telefone-validation-message telefone-validation-ok">

                                    Número disponível para cadastro.

                                </div>

                            )}

                        </div>

                    </div>


                    {/* =====================================
                SEGURANÇA
            ===================================== */}

                    <div className="conta-section seguranca-section">

                        <div className="conta-section-header">

                            <span className="section-line"></span>

                            <div>
                                <h3>Segurança</h3>

                                <p>
                                    Atualize sua senha para manter sua conta protegida.
                                </p>
                            </div>

                        </div>


                        {/* SENHA ATUAL */}

                        <div className="conta-field">

                            <label>Senha atual</label>

                            <div className="password-wrapper">

                                <input
                                    type={
                                        mostrarSenha
                                            ? "text"
                                            : "password"
                                    }

                                    name="senhaAtual"

                                    className={
                                        `conta-input ${erroSenha
                                            ? "input-erro"
                                            : ""
                                        }`
                                    }

                                    placeholder="Digite sua senha atual"

                                    value={values.senhaAtual}

                                    onChange={handleChange}
                                />

                                <button
                                    type="button"
                                    className="btn-olho"
                                    onClick={() =>
                                        setMostrarSenha(!mostrarSenha)
                                    }
                                >
                                    {mostrarSenha
                                        ? <PiEyeClosedLight />
                                        : <PiEyeLight />
                                    }
                                </button>

                            </div>

                        </div>


                        {/* NOVA SENHA */}

                        <div className="conta-field">

                            <label>Nova senha</label>

                            <div className="password-wrapper">

                                <input
                                    type={
                                        mostrarSenha
                                            ? "text"
                                            : "password"
                                    }

                                    name="novaSenha"

                                    className={
                                        `conta-input ${erroSenha
                                            ? "input-erro"
                                            : ""
                                        }`
                                    }

                                    placeholder="Digite sua nova senha"

                                    value={values.novaSenha}

                                    onChange={handleChange}

                                    onBlur={validarSenhas}
                                />

                                <button
                                    type="button"
                                    className="btn-olho"
                                    onClick={() =>
                                        setMostrarSenha(!mostrarSenha)
                                    }
                                >
                                    {mostrarSenha
                                        ? <PiEyeClosedLight />
                                        : <PiEyeLight />
                                    }
                                </button>

                            </div>


                            {erroSenha && (

                                <div className="senha-erro">
                                    {erroSenha}
                                </div>

                            )}

                        </div>

                    </div>

                </div>


                {/* FOOTER */}

                <div className="conta-footer">

                    <button
                        className="btn-salvar-conta"
                        onClick={handleSalvar}
                        disabled={loading}
                    >
                        Salvar alterações
                    </button>

                </div>

            </div>

        </div>
    );
}